module.exports = __webpack_public_path__ + "img/swivel-cupboard.62b12ee6.jpg";